import { datadogRum } from '@datadog/browser-rum';

export const setDatadogRumContext = (key: string, value: unknown) => {
  datadogRum.setGlobalContextProperty(key, value);
};

export const removeDatadogRumContext = (key: string) => {
  datadogRum.removeGlobalContextProperty(key);
};
